module.exports = __webpack_public_path__ + "static/media/ic_excel.cf6c42d2.svg";